export default __webpack_public_path__ + "static/media/birds-in-love.9fb7456e.png";